/**
 * Logger utility for Central de Atendimento Grupo Capital
 * Supports conditional debugging via ?debug=1 URL parameter or DEV mode.
 */

const isDebugEnabled = () => {
    // Check URL first
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('debug')) return true;
    }

    // Fallback to DEV mode
    return import.meta.env.DEV;
};

const logger = {
    debug: (...args) => {
        if (isDebugEnabled()) {
            console.log('[DEBUG]', ...args);
        }
    },

    info: (...args) => {
        console.log('[INFO]', ...args);
    },

    warn: (...args) => {
        console.warn('[WARN]', ...args);
    },

    error: (...args) => {
        // We always log errors for production health monitoring
        console.error('[ERROR]', ...args);
    },

    trace: (label) => {
        if (isDebugEnabled()) {
            console.trace(`[TRACE] ${label}`);
        }
    }
};

export default logger;
